import { render, staticRenderFns } from "./custom-sidebar.component.vue?vue&type=template&id=be283800&"
import script from "./custom-sidebar.component.ts?vue&type=script&lang=js&"
export * from "./custom-sidebar.component.ts?vue&type=script&lang=js&"
import style0 from "./custom-sidebar.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports